export enum PromoCodeDiscountType {
    Percentage = 0,
    FixedAmount = 1
}
